var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc"},[_c('h5',[_vm._v("\n    "+_vm._s(_vm.location)+" - "+_vm._s(_vm.year)+"\n    "),_c('br'),_vm._v(_vm._s(_vm.indicator)+"\n    "),_c('br'),_vm._v("View by: "+_vm._s(_vm.viewBy)+"\n    "),_c('br'),_vm._v("Response: "+_vm._s(_vm.response)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-088adcb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SP/SPViewTitle.vue
// module id = null
// module chunks = 